(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7082],{

/***/ 57082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Auth_ForgotView; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconNzxtLogo.js
var IconNzxtLogo = __webpack_require__(59665);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 16 modules
var hooks = __webpack_require__(83307);
// EXTERNAL MODULE: ./stores/use-ui-store/index.ts + 2 modules
var use_ui_store = __webpack_require__(86649);
// EXTERNAL MODULE: ./components/Button/index.ts + 3 modules
var Button = __webpack_require__(60820);
// EXTERNAL MODULE: ./components/ButtonLink/index.ts + 2 modules
var ButtonLink = __webpack_require__(82346);
// EXTERNAL MODULE: ./components/Input/index.ts + 2 modules
var Input = __webpack_require__(11282);
// EXTERNAL MODULE: ./components/Divider/index.ts + 2 modules
var Divider = __webpack_require__(96590);
// EXTERNAL MODULE: ./framework/utils/errors.ts + 12 modules
var utils_errors = __webpack_require__(2063);
// EXTERNAL MODULE: ./framework/commerce/use-forgot.tsx
var use_forgot = __webpack_require__(87402);
// EXTERNAL MODULE: ./framework/customer/use-customer.tsx + 1 modules
var use_customer = __webpack_require__(75524);
;// CONCATENATED MODULE: ./framework/auth/use-forgot.tsx
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ 







var defaultOpts = {
    url: "/api/maxify/auth",
    method: "PATCH"
};
var fetcher = function(options, param, fetch) {
    var email = param.email;
    if (!email) {
        throw new utils_errors/* CommerceError */.yG({
            message: "An email is required to reset password."
        });
    }
    return fetch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultOpts, options), {
        body: {
            email: email
        }
    }));
};
function extendHook(customFetcher) {
    var useForgot = function() {
        var mutate = (0,use_customer/* default */.ZP)().mutate;
        var fn = (0,use_forgot/* default */.Z)(defaultOpts, customFetcher);
        return (0,react.useCallback)(function() {
            var _forgot = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
                var data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fn(input);
                        case 2:
                            data = _ctx.sent;
                            _ctx.next = 5;
                            return mutate();
                        case 5:
                            return _ctx.abrupt("return", data);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            function forgot(input) {
                return _forgot.apply(this, arguments);
            }
            return forgot;
        }(), [
            fn,
            mutate
        ]);
    };
    useForgot.extend = extendHook;
    return useForgot;
}
/* harmony default export */ var auth_use_forgot = (extendHook(fetcher));

// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/Auth/ForgotView/styles.ts


var bgWhite = (0,tailwindcss_classnames/* classnames */.d)("bg-white");
var bgGrey800 = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-800");
var textWhite = (0,tailwindcss_classnames/* classnames */.d)("text-white");
var textLightGrey500 = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-600");
var textLightGrey800 = (0,tailwindcss_classnames/* classnames */.d)("text-nzxt-light-grey-800");
var relative = (0,tailwindcss_classnames/* classnames */.d)("relative");
var container = (0,tailwindcss_classnames/* classnames */.d)("ml-3", relative);
var flexCenter = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center");
var legalText = (0,tailwindcss_classnames/* classnames */.d)("text-xs", "px-6");
var textCenter = (0,tailwindcss_classnames/* classnames */.d)("text-center");
var forgotLinksBase = (0,tailwindcss_classnames/* classnames */.d)("pl-0", "pr-0", "text-sm");
var whiteLogo = (0,tailwindcss_classnames/* classnames */.d)(textWhite, "fill-current");
var logo = function(isInverted) {
    return (0,tailwindcss_classnames/* classnames */.d)("w-20", "h-6", "mx-auto", (0,_define_property/* default */.Z)({}, whiteLogo, isInverted));
};
var forgotWrapper = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("flex", "flex-col", "justify-center", "py-8", "sm:px-6", "lg:px-8", (_obj = {}, (0,_define_property/* default */.Z)(_obj, bgGrey800, isInverted), (0,_define_property/* default */.Z)(_obj, bgWhite, !isInverted), _obj));
};
var standaloneWrapper = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("m-auto", "max-w-lg", "lg:py-12", "flex", "flex-col", "justify-center", "py-8", "sm:px-6", "lg:px-8", (_obj = {}, (0,_define_property/* default */.Z)(_obj, bgGrey800, isInverted), (0,_define_property/* default */.Z)(_obj, bgWhite, !isInverted), _obj));
};
var forgotTopCard = (0,tailwindcss_classnames/* classnames */.d)("sm:mx-auto", "sm:w-full", "sm:max-w-md");
var forgotHeadingWrapper = (0,tailwindcss_classnames/* classnames */.d)("px-4", "sm:px-10");
var forgotHeading = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("mt-6", "text-center", "text-3xl", "font-extrabold", (_obj = {}, (0,_define_property/* default */.Z)(_obj, textWhite, isInverted), (0,_define_property/* default */.Z)(_obj, textLightGrey800, !isInverted), _obj));
};
var forgotSubheading = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("text-center", "text-sm", "mx-auto", "mt-4", "px-4", (_obj = {}, (0,_define_property/* default */.Z)(_obj, textWhite, isInverted), (0,_define_property/* default */.Z)(_obj, textLightGrey500, !isInverted), _obj));
};
var forgotBottomCard = (0,tailwindcss_classnames/* classnames */.d)("sm:mx-auto", "sm:w-full", "sm:max-w-md");
var forgotFormWrapper = (0,tailwindcss_classnames/* classnames */.d)("pt-4", "md:pt-8", "sm:px-10");
var forgotForm = (0,tailwindcss_classnames/* classnames */.d)("space-y-6");
var forgotButton = (0,tailwindcss_classnames/* classnames */.d)("mx-auto", "w-full");
var forgotSignUpWrapper = (0,tailwindcss_classnames/* classnames */.d)("mt-4", "flex", "items-center", "justify-center");
var forgotSignUpText = (0,tailwindcss_classnames/* classnames */.d)("text-center");
var notificationWrapper = (0,tailwindcss_classnames/* classnames */.d)("p-3", "rounded-md", "mb-8");
var errorWrapper = (0,tailwindcss_classnames/* classnames */.d)(notificationWrapper, "bg-error");
var successWrapper = (0,tailwindcss_classnames/* classnames */.d)(notificationWrapper, "bg-green-500");
var notification = (0,tailwindcss_classnames/* classnames */.d)("text-white", "text-sm", "font-semibold");

;// CONCATENATED MODULE: ./components/Auth/ForgotView/ForgotView.tsx
/* eslint-disable @typescript-eslint/no-shadow */ /* eslint-disable no-useless-escape */ /* eslint-disable security/detect-unsafe-regex */ /* eslint-disable max-len */ 

















var ForgotView = function(param) {
    var pageType = param.pageType, isInverted = param.isInverted;
    var ref;
    var MESSAGE_INVALID_EMAIL = (0,hooks/* useTranslation */.$G)("invalid_email");
    var MESSAGE_FORGOT_SUCCESS = (0,hooks/* useTranslation */.$G)("user_forgot_success_message");
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(""), successMessage = ref2[0], setSuccessMessage = ref2[1];
    var setModalView = (0,use_ui_store/* default */.ZP)(use_ui_store/* getSetModalView */.Bz);
    var forgot = auth_use_forgot();
    var f = (0,hooks/* useFormatMessage */.LP)();
    var ref3 = (0,index_esm/* useForm */.cI)({
        mode: "onBlur"
    }), register = ref3.register, handleSubmit = ref3.handleSubmit, getValues = ref3.getValues, clearErrors = ref3.clearErrors, setError = ref3.setError, formState = ref3.formState, reset = ref3.reset;
    var isDirty = formState.isDirty, isSubmitted = formState.isSubmitted, errors = formState.errors;
    (0,react.useEffect)(function() {
        if (isDirty && isSubmitted && errors.serverError) {
            clearErrors("serverError");
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isDirty,
        isSubmitted,
        errors
    ]);
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var errors, errorMessage, errorMessageKey, ref, formValues;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        setLoading(true);
                        _ctx.next = 4;
                        return forgot({
                            email: data.email
                        });
                    case 4:
                        setSuccessMessage(MESSAGE_FORGOT_SUCCESS);
                        clearErrors();
                        setLoading(false);
                        _ctx.next = 19;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        errors = _ctx.t0.errors;
                        errorMessage = f("error_generic");
                        errorMessageKey = (0,utils_errors/* getErrorMessageKey */.H4)(errors);
                        if (errorMessageKey) {
                            ;
                            (ref = window.heap) === null || ref === void 0 ? void 0 : ref.track(errorMessageKey);
                            errorMessage = f(errorMessageKey);
                        }
                        formValues = getValues();
                        // react-hook-form doesn't support dirtySinceLastSubmit so have to reset
                        reset(formValues);
                        setError("serverError", {
                            type: "error",
                            message: errorMessage
                        });
                        setLoading(false);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: pageType === "standalone" ? standaloneWrapper(isInverted) : forgotWrapper(isInverted),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: forgotTopCard,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconNzxtLogo/* default */.Z, {
                        className: logo(isInverted)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: forgotHeadingWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: forgotHeading(isInverted),
                                children: (0,hooks/* useTranslation */.$G)("user_reset_password")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: forgotSubheading(isInverted),
                                children: (0,hooks/* useTranslation */.$G)("user_forgot_password_subheading")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: forgotBottomCard,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: forgotFormWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            className: forgotForm,
                            onSubmit: handleSubmit(onSubmit),
                            children: [
                                (errors.serverError || successMessage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: errors.serverError ? errorWrapper : successWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: notification,
                                        children: ((ref = errors.serverError) === null || ref === void 0 ? void 0 : ref.message) || successMessage
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    "data-test-id": "email",
                                    type: "email",
                                    autoComplete: "email",
                                    inputLabel: (0,hooks/* useTranslation */.$G)("label_email_address"),
                                    labelFor: "emailAddress"
                                }, register("email", {
                                    required: true,
                                    // eslint-disable-next-line
                                    pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                })), {
                                    requiredError: errors.email && errors.email.type === "required",
                                    patternError: errors.email && errors.email.type === "pattern" && MESSAGE_INVALID_EMAIL,
                                    isInverted: isInverted
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    type: "submit",
                                    buttonStyle: "primary",
                                    loading: loading,
                                    className: forgotButton,
                                    children: (0,hooks/* useTranslation */.$G)("send")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                                    text: (0,hooks/* useTranslation */.$G)("or"),
                                    isInverted: isInverted
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: forgotSignUpWrapper,
                            children: pageType === "standalone" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                href: "/".concat(constants/* ROUTE_AUTH */.Myu, "/signin"),
                                className: forgotLinksBase,
                                internalLink: true,
                                children: (0,hooks/* useTranslation */.$G)("user_sign_in")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "button",
                                buttonStyle: "textButton",
                                onClick: function() {
                                    return setModalView("LOGIN_VIEW");
                                },
                                className: forgotLinksBase,
                                children: (0,hooks/* useTranslation */.$G)("user_sign_in")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var ForgotView_ForgotView = (/*#__PURE__*/(0,react.memo)(ForgotView));

;// CONCATENATED MODULE: ./components/Auth/ForgotView/index.ts

/* harmony default export */ var Auth_ForgotView = (ForgotView_ForgotView);


/***/ }),

/***/ 60820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@nzxt/react-icons/es/IconLoading.js
var IconLoading = __webpack_require__(2017);
;// CONCATENATED MODULE: ./components/Button/ForwardRefBase.tsx




var ForwardRefBaseButton = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref,
        // eslint-disable-next-line react/button-has-type
        type: props.type
    }, props), {
        children: props.children
    }));
});
/* harmony default export */ var ForwardRefBase = (/*#__PURE__*/(0,react.memo)(ForwardRefBaseButton));

// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/Button/styles.ts


var defaultMargin = (0,tailwindcss_classnames/* classnames */.d)("mr-2");
var styles_button = function(customMargin) {
    return (0,tailwindcss_classnames/* classnames */.d)("min-w-max", "flex", "items-center", "font-medium", "transition", "disabled:cursor-not-allowed", "h-11", (0,_define_property/* default */.Z)({}, defaultMargin, !customMargin));
};
var buttonModeLight = {
    primary: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-volt-400", "hover:bg-nzxt-volt-500", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "text-base", "rounded-md", "justify-center", "min-w-120", "md:min-w-140", "text-white"),
    secondary: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-400", "hover:bg-nzxt-dark-grey-500", "active:bg-nzxt-dark-grey-700", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "text-base", "text-white", "rounded-md", "justify-center", "min-w-120", "md:min-w-140"),
    danger: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-red-200", "text-white", "hover:bg-nzxt-red-100", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "text-base", "rounded-md", "justify-center", "min-w-120", "md:min-w-140"),
    textButton: (0,tailwindcss_classnames/* classnames */.d)("text-blue-600", "hover:underline", "disabled:text-nzxt-light-grey-500", "underline-offset")
};
var buttonModeDark = {
    primary: (0,tailwindcss_classnames/* classnames */.d)("border-white", "border-2", "text-white", "disabled:border-transparent", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "rounded-md", "justify-center", "min-w-120", "md:min-w-140"),
    secondary: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-500", "hover:bg-nzxt-dark-grey-600", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "text-base", "rounded-md", "justify-center", "min-w-120", "md:min-w-140"),
    danger: (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-red-100", "text-white", "hover:bg-nzxt-red-200", "disabled:text-nzxt-light-grey-500", "disabled:bg-nzxt-light-grey-300", "px-4", "text-base", "rounded-md", "justify-center", "min-w-120", "md:min-w-140"),
    textButton: (0,tailwindcss_classnames/* classnames */.d)("text-blue-600", "hover:underline", "disabled:text-nzxt-light-grey-500", "underline-offset")
};

// EXTERNAL MODULE: ./components/Button/buttonStyles.module.css
var buttonStyles_module = __webpack_require__(11892);
var buttonStyles_module_default = /*#__PURE__*/__webpack_require__.n(buttonStyles_module);
;// CONCATENATED MODULE: ./components/Button/Button.tsx











// TODO: The forward ref has the following type error:
// Type 'LegacyRef<HTMLButtonElement>' is not assignable to type 'Ref<HTMLButtonElement>'.
// Type 'string' is not assignable to type 'Ref<HTMLButtonElement>'.ts(2322)
// It is unclear why this issue is persisting @Donny @Tatiana
var Button = function(_param) {
    var children = _param.children, buttonStyle = _param.buttonStyle, className = _param.className, dark = _param.dark, type = _param.type, loading = _param.loading, customMargin = _param.customMargin, buttonRef = _param.buttonRef, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "buttonStyle",
        "className",
        "dark",
        "type",
        "loading",
        "customMargin",
        "buttonRef"
    ]);
    var isText = buttonStyle.includes("text");
    var composedClassName = (0,react.useMemo)(function() {
        return (0,clsx_m/* default */.Z)(styles_button(customMargin), dark ? buttonModeDark[buttonStyle] : buttonModeLight[buttonStyle], className, (0,_define_property/* default */.Z)({}, (buttonStyles_module_default()).btn, !isText));
    }, [
        buttonStyle,
        className,
        dark,
        customMargin,
        isText
    ]);
    return buttonRef ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRefBase, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        // eslint-disable-next-line
        // @ts-ignore
        ref: buttonRef,
        className: composedClassName,
        type: type
    }, rest), {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLoading/* default */.Z, {
            className: "loading-icon"
        }) : children
    })) : // eslint-disable-next-line
    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: composedClassName,
        type: type
    }, rest), {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconLoading/* default */.Z, {
            className: "loading-icon"
        }) : children
    }));
};
/* harmony default export */ var Button_Button = (/*#__PURE__*/(0,react.memo)(Button));

;// CONCATENATED MODULE: ./components/Button/index.ts

/* harmony default export */ var components_Button = (Button_Button);


/***/ }),

/***/ 96590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Divider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/Divider/styles.ts


var relative = (0,tailwindcss_classnames/* classnames */.d)("relative");
var flexCenter = (0,tailwindcss_classnames/* classnames */.d)("flex", "items-center");
var dividerWrapper = (0,tailwindcss_classnames/* classnames */.d)("absolute", "inset-0", flexCenter);
var divider = (0,tailwindcss_classnames/* classnames */.d)("w-full", "border-t", "border-gray-300");
var dividerTextWrapper = (0,tailwindcss_classnames/* classnames */.d)("relative", "flex", "justify-center", "text-sm");
var lightDivider = (0,tailwindcss_classnames/* classnames */.d)("bg-white", "text-gray-500");
var darkDivider = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-800", "text-white");
var dividerText = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("px-2", (_obj = {}, (0,_define_property/* default */.Z)(_obj, darkDivider, isInverted), (0,_define_property/* default */.Z)(_obj, lightDivider, !isInverted), _obj));
};

;// CONCATENATED MODULE: ./components/Divider/Divider.tsx



var Divider = function(param) {
    var text = param.text, isInverted = param.isInverted;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: relative,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: dividerWrapper,
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: divider
                })
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: dividerTextWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: dividerText(isInverted),
                    children: text
                })
            })
        ]
    });
};
/* harmony default export */ var Divider_Divider = (/*#__PURE__*/(0,react.memo)(Divider));

;// CONCATENATED MODULE: ./components/Divider/index.ts

/* harmony default export */ var components_Divider = (Divider_Divider);


/***/ }),

/***/ 11282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 16 modules
var hooks = __webpack_require__(83307);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./tailwindcss-classnames.ts
var tailwindcss_classnames = __webpack_require__(26167);
;// CONCATENATED MODULE: ./components/Input/styles.ts


var srOnly = "mt-2.5";
var darkInput = (0,tailwindcss_classnames/* classnames */.d)("bg-nzxt-dark-grey-700", "border-nzxt-dark-grey-700");
var input = function(isSrOnly, isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)((_obj = {}, (0,_define_property/* default */.Z)(_obj, srOnly, !isSrOnly), (0,_define_property/* default */.Z)(_obj, darkInput, isInverted), _obj), "focus:ring", "outline-none", "focus:outline-none", "focus:shadow-none", "focus:ring-nzxt-volt-400", "focus:ring-1", "focus:border-nzxt-volt-400", "appearance-none", "block", "w-full", "px-3", "py-2", "border", "border-gray-300", "rounded-md", "shadow-sm", "placeholder-gray-400", "sm:text-sm");
};
var textWhite = (0,tailwindcss_classnames/* classnames */.d)("text-white");
var textGray700 = (0,tailwindcss_classnames/* classnames */.d)("text-gray-700");
var styles_inputLabel = function(isInverted) {
    var _obj;
    return (0,tailwindcss_classnames/* classnames */.d)("block", "text-sm", "font-medium", "focus:outline-none", (_obj = {}, (0,_define_property/* default */.Z)(_obj, textWhite, isInverted), (0,_define_property/* default */.Z)(_obj, textGray700, !isInverted), _obj));
};
var errorText = (0,tailwindcss_classnames/* classnames */.d)("text-red-500", "mt-2", "text-xs");
var styles_patternMessage = (0,tailwindcss_classnames/* classnames */.d)("mt-2", "text-xs");

;// CONCATENATED MODULE: ./components/Input/Input.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ 






var Input = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var classes = _param.classes, labelFor = _param.labelFor, inputLabel = _param.inputLabel, srOnlyLabel = _param.srOnlyLabel, requiredError = _param.requiredError, generalError = _param.generalError, patternError = _param.patternError, patternMessage = _param.patternMessage, customLabelStyling = _param.customLabelStyling, isInverted = _param.isInverted, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "classes",
        "labelFor",
        "inputLabel",
        "srOnlyLabel",
        "requiredError",
        "generalError",
        "patternError",
        "patternMessage",
        "customLabelStyling",
        "isInverted"
    ]);
    var rootClassName = (0,clsx_m/* default */.Z)(input(srOnlyLabel, isInverted), {}, classes === null || classes === void 0 ? void 0 : classes.inputClass);
    var labelClassName = (0,clsx_m/* default */.Z)(styles_inputLabel(isInverted), {}, classes === null || classes === void 0 ? void 0 : classes.labelClass);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
        htmlFor: labelFor,
        className: customLabelStyling || labelClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: srOnlyLabel ? "sr-only" : null,
                children: inputLabel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                id: labelFor,
                className: rootClassName,
                ref: ref
            }, rest)),
            patternMessage && !generalError && !patternError && !requiredError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: styles_patternMessage,
                children: patternMessage
            }),
            requiredError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: errorText,
                children: (0,hooks/* useTranslation */.$G)("field_required_message")
            }),
            (generalError || patternError) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: errorText,
                children: generalError || patternError
            })
        ]
    });
});
/* harmony default export */ var Input_Input = (/*#__PURE__*/(0,react.memo)(Input));

;// CONCATENATED MODULE: ./components/Input/index.ts

/* harmony default export */ var components_Input = (Input_Input);


/***/ }),

/***/ 87402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _utils_use_action__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62253);

var useForgot = _utils_use_action__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["Z"] = (useForgot);


/***/ }),

/***/ 11892:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"buttonStyles_btn__EKYZF"};

/***/ })

}]);